import { distanceInWords } from 'date-fns';
import { orderBy } from 'lodash';
import { getTitleCase } from '../../../../../utils/formatLogicUtil';

export function getNames(applicants) {
  return applicants
    .map(({ answers: { firstName, middleName, lastName } }) =>
      [firstName, middleName, lastName].filter(Boolean).join(' '),
    )
    .filter(Boolean)
    .join(', ');
}

export function getApplicationStatus(application) {
  const { applicants } = application;
  const now = new Date();
  switch (application.overallStatus) {
    case 'approved':
      return `Approved ${distanceInWords(now, application.invitedToMoveInDateTime, { addSuffix: true })}`;
    case 'declined':
      return `Declined ${distanceInWords(now, application.declinedDateTime, { addSuffix: true })}`;
    case 'submitted': {
      const mostRecentApplicant = orderBy(applicants, ['submittedDateTime'], ['desc'])[0];
      return `Applied ${distanceInWords(now, mostRecentApplicant.submittedDateTime, { addSuffix: true })}`;
    }
    case 'partially_submitted': {
      const mostRecentApplicant = orderBy(applicants, ['submittedDateTime'], ['desc'])[0];
      return `${getTitleCase(mostRecentApplicant.answers.firstName)} ${distanceInWords(
        now,
        mostRecentApplicant.submittedDateTime,
        { addSuffix: true },
      )}`;
    }
    case 'withdrawn':
      return `Withdrawn ${distanceInWords(now, application.withdrawnDateTime, { addSuffix: true })}`;
  }
}
